import {onBeforeRouteLeave} from "vue-router";

export default {
    mounted(el, binding) {
        const tooltipContent = binding.value || el.dataset.tooltip;
        if (!tooltipContent) return;

        const tooltipElem = document.createElement('div');
        tooltipElem.classList.add('tooltip');
        tooltipElem.textContent = tooltipContent;
        document.body.appendChild(tooltipElem);

        const createTooltip = (el, content) => {
            el.addEventListener('mouseover', () => {
                tooltipElem.innerHTML = content;
                document.body.appendChild(tooltipElem);

                let coords = el.getBoundingClientRect();

                let left = coords.left + (el.offsetWidth - tooltipElem.offsetWidth) / 2;
                if (left < 0) left = 0; // не заезжать за левый край окна

                let top = coords.top - tooltipElem.offsetHeight - 5;
                if (top < 0) { // если подсказка не помещается сверху, то отображать её снизу
                    top = coords.top + el.offsetHeight + 5;
                }

                tooltipElem.style.left = left + 'px';
                tooltipElem.style.top = top + 'px';
            });

            el.addEventListener('mouseleave', () => {
                document.body.removeChild(tooltipElem);
            });
        };

        if (binding.value && typeof binding.value === 'string') {
            createTooltip(el, binding.value); // Если передано значение через v-tooltip="..."
        } else if (el.dataset.tooltip) {
            createTooltip(el, el.dataset.tooltip); // Используем data-атрибут
        }
    }
};